import Component from "../abstracts/Component";

export default class MultilineEllipsisComponent extends Component {
  get SELECTORS() {
    return {
      main: '.js-multiline-ellipsis',
      ellipsis: '.js-multiline-ellipsis-text'
    }
  }

  constructor() {
    super();
  }

  ellipsizeTextBox(el) {
    const wordArray = el.innerHTML.split(' ');

    while(el.scrollHeight > el.offsetHeight) {
      wordArray.pop();
      el.innerHTML = wordArray.join(' ') + '...';
    }
  }

  render() {
    // if (document.querySelector(this.SELECTORS.main) && this.$matchMedia('sm')) {
    //   const cardsElements = document.querySelectorAll(this.SELECTORS.main);
    //
    //   cardsElements.forEach(el => {
    //     const ellipsisElements = el.querySelectorAll(this.SELECTORS.ellipsis);
    //     ellipsisElements.forEach(el => {
    //       this.ellipsizeTextBox(el);
    //     });
    //   });
    // }
  }
}
